<template>
  <div class="time-card">
    <module-title :module-title="moduleTitle"/>
    <img
      :src="item.img"
      class="imgs"
      @click="goInfo(item)">
  </div>
</template>

<script>
import ModuleTitle from '@/components/title/ModuleTitle'
export default {
  name: 'TimeCard',
  components: {ModuleTitle},
  props: {
    banners: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      moduleTitle: {
        title: '时长卡，次卡',
        text: '咨询更优惠'
      }
    }
  },
  computed: {
    item () {
      return this.banners[0] || {}
    }
  },
  mounted () {
  },
  methods: {
    goInfo (item) {
      this.$utils.checkCanGoRouter(item.url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .time-card{
    background: #fff;
    .imgs{
      margin: $padding;
      margin-top: 0;
      width: 345px;
      height: 180px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/TimeCard.vue